import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import '../../styles/global.css';
/* eslint-disable */
import Settings from '@material-ui/icons/Settings';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import Add from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../services/api';
import {format, subDays, addDays, isAfter, parseISO} from 'date-fns';
import Tooltip from '@material-ui/core/Tooltip';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'


const useStyles = makeStyles({
    root: {
        width: '100%'
    },
    container: {
        overflow: 'none'
    }
});

export default function Index(props) {
    console.log('Propos', props);
    const MySwal = withReactContent(Swal)
    const classes = useStyles();
    let history = useHistory();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const columns = props.columns

    const rows = props.rows

    const permissaoTelas = props.telasuser;

    function editar(telasuser, id, name, email){
      // history.push('/fatura-create');
      history.push({
          // pathname: '/cliente-edit',
          pathname: `${props.tipoUsuario}-create`,
          // search: '?query=abc',
          state: { 
            type: 'edit', 
            id: id, 
            nome: name, 
            email: email,
            usuario: props.tipoUsuario,
            telasuser: telasuser
          }
      });
    }
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    function createMatricula(dados) {
      history.push({
          pathname: `matricula-create`,
          // search: '?query=abc',
          state: { 
            type: 'new',
            dadosAluno: dados,
          }
      });
    }

    function editMatricula(id) {
      history.push({
        // pathname: '/cliente-edit',
        pathname: `matricula-create`,
        // search: '?query=abc',
        state: { 
          type: 'edit', 
          id: id
        }
      });
    }

    function createMapeamento(dados) {
      history.push({
        pathname: `mapeamento-professor-create`,
        // search: '?query=abc',
        state: { 
          // type: 'new',
          telasuser: permissaoTelas,
          type: 'new',
          dadosProfessor: dados,
        }
    });
    }


    function confirmarDelete(id){
      Swal.fire({
        title: 'Tem Certeza? ',
        text: "Esta é uma ação irreversível",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, quero deletar'
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'Deletado!',
            'Este arquivo foi removido com sucesso',
            'success'
          )
          deletar(id)
        }
      })
    }
    

    async function deletar(id) {
      
      // setloading(true)
      var token = localStorage.getItem('@token_diario_web');
  
      var config = {
        headers: {Authorization: 'bearer ' + token},
      };
      try {
        const {data: prod} = await api.delete(`/usuario/${id}`, config);
        console.log("prod", prod)
        // limpaCampos();
        // setloading(false);
        toast.success('🦄 Deletado com sucesso!', {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.deletando()
      } catch (error) {
        console.log("Erro ao deletar", error, error.response);
        // setloading(false);
        toast.error('🦄 Erro ao tentar deletar, volte e tente novamente!', {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }

    return (
        <Paper className={'paper'}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column, key) => (
                                <TableCell
                                    key={column.id}
                                    align={key === 4 || key === 5? 'right' : 'left'}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {
                                return (
                                    <TableRow
                                        className="tableRow"
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row.id}>
                                          <TableCell component="th" scope="row">
                                            <p>
                                              <strong>
                                                {row.name}
                                              </strong>
                                            </p>
                                            {props.tipoUsuario === 'coordenador' && (
                                              <div>
                                                {row.escola && (
                                                  <div style={{display: 'flex', flexDirection: 'column'}}>
                                                    <span>Sede ou Polo: <strong>{row.sedePolo}</strong></span>
                                                    <span>Escola: <strong>{row.escola.escola_nome}</strong></span>
                                                    <span>Endereço: <strong>{row.escola.escola_polo_sede} - {row.escola.escola_endereco}</strong></span>
                                                    {row.permissao.length > 0 && (
                                                      <div style={{marginTop: 10}}>
                                                        <span>{row.permissao.length > 0 ? 'Coordenador geral do' : ''}</span>
                                                        {row.permissao.map((item, key) => (
                                                          <div style={{color: 'green', fontStyle: 'italic'}} key={key}>
                                                            <span>:) <strong>{item.name}</strong></span>
                                                          </div>
                                                        ))}

                                                      </div>
                                                    )}
                                                  </div>
                                                )}
                                                
                                                {!row.escola ? 'Coordenador ainda não possui Escola' : ''}
                                              </div>
                                            )}
                                            {props.tipoUsuario === 'gestor' && (
                                              <div>
                                                {row.escola && (
                                                  <div style={{display: 'flex', flexDirection: 'column'}}>
                                                    <span>Escola: <strong>{row.escola.escola_nome}</strong></span>
                                                    <span>Endereço: <strong>{row.escola.escola_polo_sede} - {row.escola.escola_endereco}</strong></span>
                                                  </div>
                                                )}
                                                
                                                {!row.escola ? 'Gestor ainda não possui Escola' : ''}
                                              </div>
                                            )}
                                          </TableCell>
                                          <TableCell align="left">
                                            {row.cpf}
                                          </TableCell>
                                          <TableCell align="left">{ format(parseISO(row.cadastro), 'dd/MM/yyyy')}</TableCell>
                                          <TableCell align="left">{row.email ? row.email : <div style={{color: 'red'}}>*Opcional*</div>}</TableCell>
                                          <TableCell align="right">{row.telefone ? row.telefone : 'Sem cadastro'}</TableCell>
                                          <TableCell align="right">
                                            {/* <Tooltip title="Editar">
                                              <IconButton
                                                component="a"
                                                // href={`/clientes/editar/abc?foo=bar`}
                                                // href="/clientes/[...slug]"
                                                href={`/faturas/editar/${row.id}`}
                                                as={`/faturas/editar/${row.id}`}
                                                aria-label="editar"
                                              >
                                                <EditIcon />
                                              </IconButton>
                                            </Tooltip> */}
                                            {row.alunoEscola && (
                                              <>
                                                {permissaoTelas.read != 0 && (
                                                  <>
                                                  {row.alunoEscola.length === 0 && (
                                                    <Tooltip title={`Matricular aluno`} aria-label="add">
                                                      <IconButton onClick={() => {createMatricula(row)}} color="inherit">
                                                          <PersonAddIcon style={{ color: 'red' }} />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                  {row.alunoEscola.length != 0 && (
                                                    <Tooltip title={`Aluno matriculado`} aria-label="add">
                                                      <IconButton onClick={() => {editMapeamento(row.alunoEscola.id)}} color="inherit">
                                                          <CheckCircleIcon style={{ color: 'green' }} />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                            {row.professorEscola && (
                                              <>
                                                {permissaoTelas.read != 0 && (
                                                  <>
                                                  {row.professorEscola.length === 0 && (
                                                    <Tooltip title={`Mapear Professor`} aria-label="add">
                                                      <IconButton onClick={() => {createMapeamento(row)}} color="inherit">
                                                          <PersonAddIcon style={{ color: 'red' }} />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                  {row.professorEscola.length != 0 && (
                                                    <Tooltip title={`Professor mapeado`} aria-label="add">
                                                      <IconButton onClick={() => {alert('Não é possível editar um mapeamento')}} color="inherit">
                                                          <CheckCircleIcon style={{ color: 'green' }} />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                            {permissaoTelas.read != 0 && (
                                              <Tooltip title={`Configurações do ${props.tipoUsuario}`} aria-label="add">
                                                <IconButton onClick={() => {editar(permissaoTelas, row.id, row.name, row.email)}} color="inherit">
                                                    <Settings />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                            {permissaoTelas.delete != 0 && (
                                              <Tooltip title="Remover cliente." aria-label="add">
                                                <IconButton onClick={() => {confirmarDelete(row.id)}} color="inherit">
                                                    <DeleteSweepIcon style={{ color: '#ff0000' }} />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                          </TableCell>
                                        {/* {columns.map((column) => {
                                            const value = row[column.id];
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number'
                                                        ? column.format(value)
                                                        : value}
                                                </TableCell>
                                            );
                                        })} */}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={'Por página'}
            />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
        </Paper>
    );
}
